// extracted by mini-css-extract-plugin
export var desktopNavBar = "DesktopNavbar-module--desktop-nav-bar--3WaE3";
export var active = "DesktopNavbar-module--active--3wxvz";
export var link = "DesktopNavbar-module--link--2ysG4";